import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import LazyComponent from '../../../LazyComponent';

export default universal(
    universalImport({
        chunkName: () => 'LazyOrdersChunk',
        path: () => path.join(__dirname, './OrdersConnect'),
        resolve: () => require.resolveWeak('./OrdersConnect'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "LazyOrdersChunk" */ './OrdersConnect')]).then(
                (proms) => proms[0]
            ),
    }),
    LazyComponent.loaderResource
);
